import { USER_TYPES } from "src/constants";
import { COLOR_LIST } from "src/constants/cases";
import { AuthenticatedHCPHeader, AuthenticatedManufactureHeader } from "src/constants/headerLinks";
import { GeographicalStatisticsObject, topPayorsMOSECRProps } from "src/pages/manufacturer/types";
import { HeaderElement } from "src/types";

export const objectToQueryString = (obj:any) => {
  const keys = Object.keys(obj);
  const keyValuePairs = keys.map(key => {
    return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
  });
  return keyValuePairs.join("&");
  // more code goes here
}
export const wrapperFunction = (value: GeographicalStatisticsObject[]) => {
  const dataArray : [string, number][] = [];
  value.forEach((item) => {
    const array: [string, number] = ['us-'+item.state.toLocaleLowerCase(), item.case_count]
    dataArray.push(array)
  })
  return dataArray;
}
export const wrapperFunctionPieChart = (
  pieChartData: topPayorsMOSECRProps[]
) => {
  return [
    {
      name: "Percentage",
      type: "pie",
      data: pieChartData && pieChartData.length>0 && pieChartData.map((item,key) => (item.name !== 'ALL TOP 10' &&
        {
        name: `${(item.name || "")
          .toLowerCase()
          .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())} <b>(${
          item.value
        })</b>`,
        title:`${(item.name || "")
          .toLowerCase()
          .replace(/(^\w|[-\s]\w)/g, (match) => match.toUpperCase())}`,
        value:item.value,
        y: item.percentage,
        color:COLOR_LIST[key]
      }
    )),
    },
  ];
};
export const formatPhoneNumber = (phoneNumber: number | string): string => {
  const cleaned = (phoneNumber)?.toString()?.replace(/\D/g, '');
  if (cleaned && cleaned.length !== 10) {
    return phoneNumber?.toString(); // Return as-is if not valid
  }
  return cleaned?.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const secondFormatPhoneNumber = (phoneNumber: number | string): string => {
  const cleaned = (phoneNumber)?.toString()?.replace(/\D/g, '');
  if (cleaned && cleaned.length !== 10) {
    return phoneNumber?.toString(); // Return as-is if not valid
  }
  return cleaned?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
};

export const getRole = () => {
    return localStorage.getItem("changeRole")
  }
  export const isNotKAMUser = (ref_type:string) => {
     if (ref_type === "rep") {
       return false;
     }
     return true;
  }

  export const isPhiEligible = (ref_type: string) => {
    const isPhysicianUser = ["GlobalDoctor", "Practice", "Organization", "Contact"].includes(ref_type);
    return isPhysicianUser || ["area_manager", "district_manager","fad"].includes(ref_type);
  }

export function isMobileOrTablet() {
  const ua = navigator.userAgent.toLowerCase();

  // Check via userAgentData (Chromium-based browsers only)
  if (Object.hasOwn(navigator, "userAgentData")) {
    (navigator as any).userAgentData.getHighEntropyValues(["model"])
      .then((data: any) => {
        if (/mobile|iphone|ipod|android|ipad|tablet/i.test(data.model || '')) {
          return true;
        }
      })
      .catch(() => false);
  }

  // Traditional UA check (covers older iPads or browsers that expose 'iPad')
  if (/mobile|iphone|ipod|android|ipad|tablet/.test(ua)) {
    return true;
  }

  // Modern iPads (iPadOS 13+) spoof as Mac, so detect Mac + touch screen
  const isMacTouchDevice =
    /macintosh/.test(ua) && navigator.maxTouchPoints > 1;

  return isMacTouchDevice;
}

export function checkCookie(name: string) {
  // document.cookie returns something like: "username=JohnDoe; theme=dark"
  return document.cookie
    .split("; ")
    .some((row) => row.startsWith(name + "="));
}
export const checkLandingPageExists = (
  refType: string,
  redirectLink: string
): boolean => {
  let headerList: HeaderElement[] = [];

  if (USER_TYPES.MANUFACTURER.includes(refType)) {
  headerList = AuthenticatedManufactureHeader;
} else if ((USER_TYPES.HCP.includes(refType))) {
  headerList = AuthenticatedHCPHeader;
} else {
  return false;
}

  // check both top-level and dropdown links
  for (const item of headerList) {
    //console.log(item)
    if (item.redirectLink === "/"+redirectLink) return true;
    if (item.dropdown?.some((d) => d.redirectLink === redirectLink)) return true;
  }

  return false;
};

export const handleNavigation = (defaultView: string, pathname: string): boolean => {
  const targetPath = defaultView.includes("/") 
    ? defaultView 
    : `/${defaultView}`;
  
  if (pathname === targetPath) {
    // 🎯 Already on target path - just refresh the page
    return false;
  } else {
    // Different path - navigate then refresh
    return true;
    // If you need to ensure refresh after navigation:
    // setTimeout(() => navigate(0), 0);
  }
};
